import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ManageUsersPage = ({ token }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: '', name: '', date_end: '', password: '' });
  const [editingId, setEditingId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [showCompaniesId, setShowCompaniesId] = useState(null);
  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/users`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUsers(res.data);
    } catch (err) {
      console.error('Error fetching users:', err);
    }
  };
  useEffect(() => {
    if (token) fetchUsers();
  }, [token]);
  const fetchUserCompanies = async (id) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/users/${id}/companies`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCompanies(res.data);
      setShowCompaniesId(id);
    } catch (err) {
      console.error('Error fetching user companies:', err);
    }
  };
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_BASE_URL}/api/admin/users/${editingId}`,
          { email: form.email, name: form.name },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(`${API_BASE_URL}/api/admin/users`, form, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      setForm({ email: '',  password: '', name: '', date_end: '', });
      setEditingId(null);
      fetchUsers();
    } catch (err) {
      console.error('Error saving user:', err);
    }
  };
  const handleEdit = (user) => {
    setForm({ email: user.email, name: user.name, password: '' });
    setEditingId(user.id_user);
  };
  const handleDelete = async (id) => {
    if (!window.confirm('Delete user?')) return;
    try {
      await axios.delete(`${API_BASE_URL}/api/admin/users/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchUsers();
    } catch (err) {
      console.error('Error deleting user:', err);
    }
  };
  return (
    <div>
      <h1>Administrar Usuarios</h1>
      <form onSubmit={handleSubmit}>
        <input
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          name="name"
          placeholder="Nombre"
          value={form.name}
          onChange={handleChange}
          required
        />
        <input
          name="date_end"
          placeholder="Fecha Fin MM-DD-YYYY"
          value={form.date_end}
          onChange={handleChange}
          required
        />
        {!editingId && (
          <input
            name="password"
            type="password"
            placeholder="Contraseña"
            value={form.password}
            onChange={handleChange}
            required
          />
        )}
        <button type="submit">{editingId ? 'Actualizar' : 'Crear'}</button>
        {editingId && <button onClick={() => { setEditingId(null); setForm({ email: '', name: '', password: '' }); }}>Cancelar</button>}
      </form>

      <h2>Usuarios</h2>
      <ul>
        {users.map((u) => (
          <li key={u.id_user}>
            {u.email} ({u.name}) {u.created_at}    FIN    {u.finish_date}
            <button onClick={() => handleEdit(u)}>Editar</button>
            <button onClick={() => handleDelete(u.id_user)}>Eliminar</button>
            <button onClick={() => fetchUserCompanies(u.id_user)}>Ver Empresas</button>
            {showCompaniesId === u.id_user && companies.length > 0 && (
              <ul>
                {companies.map((c) => (
                  <li key={c.id_company}>
                    {c.name} - {c.start_date ? new Date(c.start_date).toLocaleDateString() : ''} a {c.end_date ? new Date(c.end_date).toLocaleDateString() : ''}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ManageUsersPage;
